import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ConfigProvider } from 'antd';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
    mutations: { retry: 0 },
  },
});

const theme = {
  token: {
    fontSize: 14, // Minimum 14px per CLAUDE.md K-12 readability requirement
    colorPrimary: '#4F46E5',
    colorLink: '#4F46E5',
    borderRadius: 8,
    borderRadiusSM: 6,
    borderRadiusLG: 12,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f8fafc',
    colorBorder: '#e2e8f0',
    colorBorderSecondary: '#f1f5f9',
    colorTextHeading: '#0f172a',
    colorTextBase: '#1e293b',
    colorTextSecondary: '#64748b',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
    boxShadowSecondary: '0 4px 16px rgba(0,0,0,0.08)',
  },
  components: {
    Card: {
      boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      paddingLG: 20,
    },
    Table: {
      headerBg: '#f8fafc',
      headerColor: '#64748b',
      headerSortActiveBg: '#f1f5f9',
      rowHoverBg: '#fafafa',
      borderColor: '#f1f5f9',
    },
    Button: {
      fontWeight: 500,
    },
    Input: {
      paddingBlock: 7,
    },
    Select: {
      optionSelectedBg: '#ede9fe',
    },
    Menu: {
      itemBorderRadius: 6,
      itemMarginInline: 8,
    },
    Statistic: {
      titleFontSize: 13,
      contentFontSize: 28,
    },
  },
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={theme}>
        <App />
      </ConfigProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
);
